import React, { useState, useEffect } from "react";
import { Translate } from "react-i18nify";
import { useKioskHorizontalStyles } from "./../../../../kioskstyles";
import formatAddress from "./../../HelperFunctions/formatAddress";
import { useNavigate } from "react-router-dom";
import "./../../../../font.css";

// Using a functional component, you must wrap it in React.forwardRef, and then forward the ref to
// the node you want to be the root of the print (usually the outer most node in the ComponentToPrint)
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-function-components
function KioskDetail(props) {
  const { getKioskConfiguration } = props;

  const [locationAddress, setLocationAddress] = useState("");
  const [locationName, setLocationName] = useState("");

  const kioskstyles = useKioskHorizontalStyles();

  const navigate = useNavigate();

  useEffect(() => {
    const kioskConfig = getKioskConfiguration();

    if (kioskConfig == undefined || kioskConfig == null) {
      return navigate("/errorscreen");
    }

    setLocationAddress(kioskConfig.locationAddress);
    setLocationName(kioskConfig.locationName);
  }, []);

  const isNullOrWhitespace = input => {
    return !input || !input.trim();
  };

  if (isNullOrWhitespace(locationName) || isNullOrWhitespace(locationAddress)) {
    return <></>;
  }

  return (
    <div class="fontSecondaryText" style={kioskstyles.whiteBodyText}>
      <Translate
        value="application.theme.wizardAddressText"
        name={locationName}
        address={formatAddress(locationAddress)}
      />
    </div>
  );
}

export default KioskDetail;
